import { render, staticRenderFns } from "./PayrollFormEdit.vue?vue&type=template&id=2fd8dc9c&"
import script from "./PayrollFormEdit.vue?vue&type=script&lang=js&"
export * from "./PayrollFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./PayrollFormEdit.vue?vue&type=style&index=0&id=2fd8dc9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports